import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DialogActions, Button } from '@material-ui/core';

export const AddLineItemsDialogFooter = ({
  onAddLineItems,
  onClose,
  disableAdd,
  addButtonLabel,
  saveInProgress,
  createBill,
  createAndViewInProgress,
  billingBatchState
}) => {
  const onAdd = useCallback(
    item => async () => {
      onAddLineItems(item);
    },
    [onAddLineItems]
  );

  return (
    <DialogActions>
      <Button
        onClick={onClose}
        disabled={
          saveInProgress ||
          createAndViewInProgress ||
          billingBatchState?.batchInProgress
        }
        data-qe-id="addLineItemsDialogFooter_cancel"
      >
        <FormattedMessage id="button.cancel" />
      </Button>
      <Button
        onClick={onAdd(false)}
        disabled={disableAdd}
        color="primary"
        data-qe-id="addLineItemsDialogFooter_createBill"
      >
        <FormattedMessage id={addButtonLabel} />
      </Button>
      {createBill ? (
        <Button
          onClick={onAdd(true)}
          disabled={disableAdd || createAndViewInProgress}
          color="primary"
        >
          <FormattedMessage id="addLineItemDialog.createAndViewBill" />
        </Button>
      ) : null}
    </DialogActions>
  );
};

AddLineItemsDialogFooter.propTypes = {
  disableAdd: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAddLineItems: PropTypes.func,
  addButtonLabel: PropTypes.string.isRequired,
  saveInProgress: PropTypes.bool.isRequired,
  createBill: PropTypes.bool,
  createAndViewInProgress: PropTypes.bool,
  billingBatchState: PropTypes.object
};

export default AddLineItemsDialogFooter;
